export default {
    intro: ({ values }: { values: { isAuto: boolean; questionTime: number; answerTime: number } }) => {
        const { isAuto, questionTime, answerTime } = values;
        if (isAuto) {
            return `在${answerTime}秒内查看题目，在${questionTime}秒内选择对或错！`;
        } else {
            return '看题目，选择O/X！';
        }
    },
    options: {
        auto: '自动进行',
        manual: '手动进行',
        timer: '计时器设置',
        answerTime: '题目查看时间',
        questionTime: '答案选择时间',
        answerCheckTime: '答案确认时间',
        showOtherAvatar: '显示所有头像',
        showOtherAvatarDescription: '选择是否在学生画面中OX选择时显示其他学生的头像。',
    },
    topbar: {
        check: '请查看题目。',
        question: '请选择正确答案。',
        result: '答案揭晓！',
        default: '有趣的OX 测验',
    },
    buttons: {
        standby: '公布题目',
        question: '截止选择并公布答案',
        check: '开始选择',
        unclickUser: {
            unselect: '查看未选择<br />人员',
            allSelect: '全部<br />已选择！',
            count: '{count}人',
        },
        next: '下一题',
    },
    modal: {
        unselect: '未选择的学生',
        timerError: '如果要以自动模式开始OX 测验，<br>请设置所有三个计时器。',
    },
    toast: { unselect: '选择答案前，请先查看题目！' },
    standbyStep: ({ values }: { values: { index: number } }) => {
        const { index } = values;
        const messages = ['正在给气球<br />充气...', '正在加热<br />热气球...', '正在进行<br />安全检查...'];
        return messages[index];
    },
    resultStep: {
        result: '正确答案是 <i></i>。',
        nextQuestion: '{time}秒后开始下一题！',
    },
    autoMode: '正在以自动模式进行。',
    questionAccuracy: {
        content: ({ values }: { values: { questionText: string; correctChoice: boolean } }) => {
            const { questionText, correctChoice } = values;
            return `${questionText} <strong>${correctChoice ? '(O: 对)' : '(X: 错)'}</strong>`;
        },
    },
    correctChoice: { true: '对', false: '错' },
    question: '题目',
    answer: '正确答案',
    explanation: '解析',
    additionalMaterial: '补充资料',
    explanationMaterial: '解析资料',
    table: { question: '题目', answerRate: '正确率' },
    isAnswer: '正确答案是？',
    roundNumber: '第{number}题',
    timer: {
        remaining: '{count}秒',
    },
};
